import React, { useEffect } from 'react';
import { Pane, Text } from 'evergreen-ui';
import { Button } from '../../components';
import { ReactComponent as CardIcon } from '../../assets/icons/credit-card-light.svg';
import { ReactComponent as PaypalIcon } from '../../assets/icons/paypal-icon.svg';

const PaymentSelectionScreen = ({
    booking,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    nextScreen,
}) => {
    useEffect(() => {
        if (booking) {
            window.analytics.track('Complete Booking - Select payment', {
                booking_id: booking._id,
                content_ids: [booking._id],
                contents: [{ id: booking._id }],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Pane>
            <Pane
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                textAlign="center"
                marginTop={30}
            >
                <Text>Select your preferred payment method</Text>
                <Pane display="flex" gap={10} marginTop={10}>
                    <Button
                        key={`payment_btn_stripe`}
                        appearance={selectedPaymentMethod === 'stripe' ? 'primary' : 'outlined'}
                        onClick={() => setSelectedPaymentMethod('stripe')}
                    >
                        <CardIcon style={{ marginRight: '10px' }} width={16} height={16} />
                        Card
                    </Button>
                    <Button
                        key={`payment_btn_paypal`}
                        appearance={selectedPaymentMethod === 'paypal' ? 'primary' : 'outlined'}
                        onClick={() => setSelectedPaymentMethod('paypal')}
                    >
                        <PaypalIcon style={{ marginRight: '10px' }} width={16} height={16} />
                        Paypal
                    </Button>
                </Pane>
                <Pane display="flex" justifyContent="end">
                    <Button
                        onClick={nextScreen}
                        appearance="primary"
                        disabled={!selectedPaymentMethod}
                        margin="10px 0 0 0"
                    >
                        Continue →
                    </Button>
                </Pane>
            </Pane>
        </Pane>
    );
};

export default PaymentSelectionScreen;
